import { Scene } from "@babylonjs/core/scene";
import { LayeredTexture } from "./layerdTexture";

export type TextureType = "albedo" | "normal" | "metalRough" | "emissive";

export class TextureSet {
  public albedo: LayeredTexture;
  public normal: LayeredTexture;
  public metalRough: LayeredTexture;
  public emissive: LayeredTexture;

  public constructor(name: string, size: number, scene: Scene, layers: number = 3) {
    this.emissive   = new LayeredTexture(`rtt.${name}.emissive`, size, scene, { generateMipMaps: true }, true);
    this.albedo     = new LayeredTexture(`rtt.${name}.albedo`, size, scene, { generateMipMaps: true });
    this.normal     = new LayeredTexture(`rtt.${name}.normal`, size, scene, { generateMipMaps: true });
    this.metalRough = new LayeredTexture(`rtt.${name}.metalRough`, size, scene, { generateMipMaps: true });
  }

  getTexture(type: TextureType): LayeredTexture {
    switch (type) {
      case "albedo": return this.albedo;
      case "normal": return this.normal;
      case "metalRough": return this.metalRough;
      case "emissive": return this.emissive;
      default:
        throw new Error("Invalid Texture Type");
    }
  }
}